<!-- Wrapper for Bootstrap icons, see https://icons.getbootstrap.com/ -->

<script lang="ts">
    export let icon:
        | "chevron-right"
        | "chevron-left"
        | "chevron-double-right"
        | "camera-fill"
        | "arrow-repeat"
        | "emoji-smile"
        | "emoji-angry"
        | "box-arrow-up-right"
        | "exclamation-circle-fill";
</script>

<i class="bi bi-{icon}" />
